import { getFirstTwoLetters } from "@/features/shared/utils";

import * as styled from "./styled";

export enum AvatarCardType {
  DASHBOARD = "dashboard",
  ORGANISATION = "organisation",
}

interface AvatarCardProps {
  to: string;
  name: string;
  tags?: string[];
  label?: string;
  type?: AvatarCardType;
}

const AvatarCard = ({
  to,
  name,
  tags,
  label,
  type = AvatarCardType.DASHBOARD,
}: AvatarCardProps) => {
  return (
    <styled.AvatarCard to={to} tabIndex={0}>
      <styled.AvatarCardLogo type={type}>
        <span>{getFirstTwoLetters(name)}</span>
      </styled.AvatarCardLogo>
      <div>
        <styled.AvatarCardTitle>{name}</styled.AvatarCardTitle>
        {tags && (
          <div>
            {tags.map((tag) => (
              <styled.AvatarCardTag key={tag}>{tag}</styled.AvatarCardTag>
            ))}
          </div>
        )}
        {label && <styled.AvatarCardLabel>{label}</styled.AvatarCardLabel>}
      </div>
    </styled.AvatarCard>
  );
};

export default AvatarCard;
